import { ChangeEvent, ReactNode, useContext } from "react";
import { Stack, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AppContext } from "context/appContext";
import { PermitType } from "types";
import AuturaDropdown from "components/inputs/AuturaDropdown";
import { getBlankPermitType } from "utils";

export interface PermitTypeWidgetProps {
  options: PermitType[];
  permitType: PermitType;
  setPermitType: (permitType: PermitType) => void;
}

const PermitTypeWidget = ({
  options,
  permitType,
  setPermitType,
}: PermitTypeWidgetProps): ReactNode => {
  const { t } = useTranslation();
  const { state: appState } = useContext(AppContext);

  const handleSelectPermitType = (e: ChangeEvent<HTMLInputElement>) => {
    if (!appState.tenant) {
      return;
    }
    const permitType = options.find((pt) => pt.name === e.target.value);
    if (permitType) {
      setPermitType(permitType);
    } else {
      setPermitType(getBlankPermitType(appState.tenant.id));
    }
  };

  return (
    <Stack direction="column" spacing={0} flex={2}>
      <Grid container width={"100%"} spacing={3}>
        <Grid size={12}>
          <AuturaDropdown
            name="permit.permitType"
            label={t("permit_type.label", { ns: "entities" })}
            initialValue={permitType.name}
            value={permitType.name}
            setValue={handleSelectPermitType}
            options={options.map((pt) => pt.name)}
            required
          />
        </Grid>
      </Grid>
    </Stack>
  );
};

export default PermitTypeWidget;
